import { render, staticRenderFns } from "./MedicalRecords.vue?vue&type=template&id=e9400654"
import script from "./MedicalRecords.vue?vue&type=script&lang=js"
export * from "./MedicalRecords.vue?vue&type=script&lang=js"
import style0 from "./MedicalRecords.vue?vue&type=style&index=0&id=e9400654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports